import React from 'react';
import { TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import TransactionHistoryExamRegistration from '../../modules/subject/components/TransactionHistoryExamRegistration';

const TransactionHistoryRegistrationHistory = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('exam->>RegistrationSummary.ViewRegistration')} />
      <TransactionHistoryExamRegistration />
    </>
  );
};

export default TransactionHistoryRegistrationHistory;
